import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'eventy/';

let URL_CLIENT = AppConfig.HOST_CLIENT_API();

export default {

    pobierzWszytskieEventy() {
        return axios({
            method: 'get',
            url: URL_CLIENT+'strona/wpis/byTypAndAktywny/EVENT/true',
        });
    },

    pobierzListeZapisanychDoEventu(id) {
        return axios({
            method: 'get',
            url: URL+id
        });
    },

}


// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eventy/EventyService.js